<script>
import {
  bApp,
  baseTermUrl,
  insTypeOrders,
  preHandleKeys,
  contrastShowKeys,
} from 'base/config'
import { formatTenThousand, formatASCII } from 'common/js/format'
import { haveDisease, haveShowProductName, stuffingTemplateIns } from './common'
import Insurance from 'base/model/insurance'
import Emitter from 'common/js/emitter'
import { toggleClass, getScreenSize } from 'common/js/dom'
import ToggleDesc from 'components/toggleDesc/toggleDesc'
import PbDialog from 'components/dialog/dialog'

const LEFT_WIDTH = 67 + 30

export default {
  components: {
    ToggleDesc,
    PbDialog,
  },
  mixins: [Emitter],
  props: {
    temp: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    },
    profitBtn: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    //
    /**
     * 显示/隐藏 责任
     * @param  {Element} dom [责任所在dom]
     */
    toggleDesc(dom) {
      dom.parentNode && toggleClass(dom.parentNode, 'ins-desc-show')
    },

    clickPftHandler(event, index) {
      event.stopPropagation()
      event.preventDefault()
      this.dispatch('InsResultContrast', 'open-profit', index)
    },

    /**
     * 格式数据
     * @return {Object} [险种格式数据, 责任格式数据]
     */
    _normalizeData(template) {
      let temp = template.liabilities
      let arrangeInIns = []
      let arrangeInInsType = []
      let arrangeBase = []
      let categorySort = temp.categorySort || 'normal'
      let insTypeOrder = insTypeOrders[categorySort]
      let instypeDisease = {}
      const resultData = template.resultData

      let diseaseBaseTypes = {}
      let insuranceBaseCompare = {}

      for (let pidx = 0, plen = temp.length; pidx < plen; pidx++) {
        let product = temp[pidx] // 产品
        let productId = product.productId
        let insurance = product.insuranceLiabilities
        let insuranceLen = insurance && insurance.length
        let arrangeProduct = []
        // let diseasesPath = []

        let diseaseTypes = {}
        let insuranceCompare = {}

        if (!insuranceLen) continue
        for (let idx = 0; idx < insuranceLen; idx++) {
          let ins = insurance[idx] // 险种
          let insId = ins.insuranceId // 险种id
          // let insName = ins.insuranceName // 险种名字
          let liabilities = ins.liabilities // 责任
          let liabilitiesLen = liabilities && liabilities.length
          let disease // 险种-所有责任的病重
          if (!liabilitiesLen) continue

          for (let lidx = 0; lidx < liabilitiesLen; lidx++) {
            let liab = liabilities[lidx] // 责任
            let liabType = liab.categoryId // 责任类别
            let liabTypeName = liab.categoryName // 责任类别名
            let liabOrder = insTypeOrder.indexOf(liabType) // 责任排序
            if (liabOrder < 0) continue

            const type = liab.disease.diseaseCategoryType
            const dsid = liab.disease.diseaseCategoryId
            const dkey = ['serious', 'disease', 'mild'][type - 1]
            const isHuomian =
              resultData.productGroupList[0].prodOrderList[pidx]
                .mulInsOrderList[idx].huomian

            if (dkey && !isHuomian) {
              if (!insuranceCompare[dkey]) {
                insuranceCompare[dkey] = insId
              }
              if (!diseaseTypes[productId]) {
                diseaseTypes[productId] = {
                  [dkey]: dsid,
                }
              } else if (!diseaseTypes[productId][dkey]) {
                diseaseTypes[productId][dkey] = dsid
              }
            }

            // 病种
            if (liab.disease && liab.disease.title) {
              disease = {
                pidx, // 产品index
                idx, // 险种
                lidx, // 责任
              }
              // 区别 产品-险种
              // const index = idx + pidx

              // 当前责任类型
              if (Array.isArray(instypeDisease[liabOrder])) {
                instypeDisease[liabOrder].push(disease)
              } else {
                instypeDisease[liabOrder] = [disease]
              }
            }
            liab.productId = productId

            // 同责任不同产品
            // && productId === arrangeBase[liabOrder].productId
            if (
              arrangeBase[liabOrder] &&
              Array.isArray(arrangeBase[liabOrder]['liabilities'])
            ) {
              arrangeBase[liabOrder]['liabilities'].push(liab)
            } else {
              arrangeBase[liabOrder] = {
                liabilities: [liab],
                liabTypeName,
              }
            }
          }
          // diseasesPath.push(disease)
        }

        Object.assign(diseaseBaseTypes, diseaseTypes)
        Object.keys(insuranceCompare).length > 0 &&
          (insuranceBaseCompare[productId] = insuranceCompare)
        arrangeInIns.push(arrangeProduct)
      }
      Object.keys(arrangeBase).forEach((key) => {
        const itdArry = instypeDisease[key]
        const result = []
        let prePidx = -1
        let preIdx = -1
        if (Array.isArray(itdArry)) {
          itdArry.forEach((itd) => {
            const { pidx, idx } = itd
            if (prePidx === pidx && preIdx === idx) {
              result[result.length - 1].push(itd)
            } else {
              result.push([itd])
            }
            prePidx = pidx
            preIdx = idx
          })
        }
        arrangeBase[key].itDisease = result
      })
      return {
        arrangeInIns,
        arrangeInInsType,
        arrangeBase,
        diseaseBaseTypes,
        insuranceBaseCompare,
      }
    },
    /**
     * 创建责任
     * @param  {Array} base [description]
     * @param  {Function} arrangeBase
     */
    _createInsTypeVNodeV2(base, arrangeBase) {
      const {
        temp: { name, planLib, insuranceTypeId, productNameListData },
        __c,
        _createLiabilitiesV2,
      } = this

      const insTypeOrder = insTypeOrders.normal
      const result = []

      base.forEach((item, index) => {
        if (!Array.isArray(planLib)) return
        const theInsTypeAry = []
        planLib.forEach((plan, planIndex) => {
          const insAry = []
          const instypeAry = []
          const ins = arrangeBase[planIndex][index]

          if (ins) {
            const {
              // productId,
              insuranceId,
              insuranceName,
              liabilities,
              // liabTypeName,
              // accountMap,
            } = ins
            const { bDisease, bHideDesc } = haveDisease(liabilities)
            const bProductShow = haveShowProductName(
              ins.liabilities,
              insTypeOrder[index],
              productNameListData
            )
            const insChilds = []

            // let bAddAndTake = 0
            // let bInstypeHideDesc = false

            // header
            const termVNode = __c('a', {
              class: 'term-link',
              attrs: {
                href: `${baseTermUrl}?nw=1&name=${name}&termsId=${insuranceId}`,
                'data-stat-id': 'tkxq',
                'data-stat-ep': JSON.stringify({
                  productId: insuranceTypeId,
                }),
              },
              domProps: {
                innerHTML: '条款',
              },
            })
            const insHeadVNode = __c(
              'h5',
              {
                class: 'ins-name',
              },
              [insuranceName, termVNode]
            )
            insChilds.push(insHeadVNode)

            // body
            if (liabilities) {
              const insBodyChilds = _createLiabilitiesV2(
                planIndex,
                bProductShow,
                liabilities
              )
              const insBodyVNode = __c(
                'div',
                {
                  class: 'ins-bd',
                },
                insBodyChilds
              )
              insChilds.push(insBodyVNode)
            }

            // 追加领取
            // if (accountMap) {
            //   const insAddAndTakeChilds = this._createAddAndTake(accountMap, create)
            //   if (insAddAndTakeChilds.length) {
            //     let insAddAndTakeVNode = create('div', {
            //       class: 'ins-bd add-take'
            //     }, insAddAndTakeChilds)
            //     insChilds.push(insAddAndTakeVNode)
            //     bAddAndTake++
            //   }
            // }

            // foot
            const insFootVNode = __c(ToggleDesc, {
              on: {
                toggle: this.toggleDesc,
              },
            })
            insChilds.push(insFootVNode)

            if (insChilds.length) {
              const insVNode = __c(
                'div',
                {
                  class: 'ins-box',
                },
                insChilds
              )
              insAry.push(insVNode)
            }

            if (insAry.length) {
              const instypeNameChild = []
              if (bDisease) {
                const instypeDiseaseVNode = __c(
                  'a',
                  {
                    class: 'disease-btn after-bdr',
                    on: {
                      click: this.handleClick.bind(
                        this,
                        event,
                        ins.itDisease,
                        planIndex
                      ),
                    },
                  },
                  '病种详情'
                )
                instypeNameChild.push(instypeDiseaseVNode)
              }

              const instypeNameVNode = __c(
                'div',
                {
                  class: 'disease-btn',
                },
                instypeNameChild
              )
              // insAry.unshift(instypeNameVNode)
              insAry.push(instypeNameVNode)

              if (bHideDesc) {
                const instypeToggleFootVNode = __c(ToggleDesc, {
                  on: {
                    toggle: this.toggleDesc,
                  },
                })
                insAry.push(instypeToggleFootVNode)
              }

              // const sectionClass = bAddAndTake > 0 ? (bAddAndTake > 1 ? 'instype-box addtake-box' : 'instype-box addtake-box no-title') : 'instype-box'
              const instypeVNodes = __c(
                'section',
                {
                  // class: bAddAndTake > 1 ? 'instype-box addtake-box' : 'instype-box'
                  class: 'instype-box',
                },
                insAry
              )
              instypeAry.push(instypeVNodes)
            }
          } else {
            const instypeVNodes = __c(
              'section',
              {
                class: 'instype-box',
                domProps: {
                  innerHTML: '<div class="ins-bd empty">—</div>',
                },
              },
              insAry
            )
            instypeAry.push(instypeVNodes)
          }

          theInsTypeAry.push(
            __c(
              'article',
              {
                class: 'des-box',
                style: {
                  width: `${this.itemWidth}px`,
                },
              },
              instypeAry
            )
          )
        })
        result.push(
          __c(
            'div',
            {
              class: 'one-instype-item',
            },
            theInsTypeAry
          )
        )
      })

      return result
    },
    /**
     * 创建责任
     * @param  {Number} planIndex        [产品序列]
     * @param  {Boolean} bProductShow    [分产品显示]
     * @param  {Object} liab             [责任对象]
     * @return {Array}                   [VNode, VNode]
     */
    _createLiabilitiesV2(planIndex, bProductShow, liab) {
      const {
        temp: { productNameListData },
        __c,
        _createProductVNode,
      } = this
      let ret = []
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      let preProductName = null
      targetAry.forEach((lib) => {
        const prodId = lib.productId
        const productName = prodId && productNameListData[prodId]
        if (bProductShow && preProductName != productName) {
          ret.push(_createProductVNode(productName, preProductName))
          preProductName = productName
        }
        lib &&
          contrastShowKeys.forEach((sk, index) => {
            let libItem = lib[sk]
            if (libItem) {
              let resultHTML
              try {
                resultHTML = this.format(prodId, libItem, this.data[planIndex])
              } catch (er) {
                resultHTML = this.formatLow(
                  prodId,
                  libItem,
                  this.data[planIndex]
                )
              }

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length &&
                  preHandleKeys.forEach((pre) => {
                    if (pre.key === sk) {
                      resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                    }
                  })

                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML,
                  },
                })
                ret.push(libVNode)
              }
              // if (sk === 'description1') {
              //   if (index === 0) {
              //     if (haveShowProductName)
              //     _createProductVNode(productName, preProductName)
              //     preProductName = productName
              //     ret.unshift()
              //   } else {

              //   }
              // }
            }
          })
      })

      return ret
    },
    /**
     * 创建产品名节点
     * @param  {String} name [名称]
     * @param  {Bollean} segm [分割]
     * @return {Array}      [list[VNode]]
     */
    _createProductVNode(name, segm) {
      let rst = []
      let { __c } = this
      if (segm) {
        rst.push(
          __c('div', {
            class: 'product-name-line after-bd-b',
          })
        )
      }
      rst.push(
        __c(
          'h4',
          {
            class: 'product-name',
          },
          name
        )
      )

      return rst
    },
    /**
     * 显示/隐藏 病种
     * @param  {Object} event
     * @param  {Object} path  [路径]
     */
    handleClick(event, path, index) {
      // this.$emit('openDisease', 'open-disease', path, index)
      this.dispatch('InsResultContrast', 'open-disease', [path, index])
    },
    _getMaxLen(ary) {
      let compare = []
      let result = []
      ary.forEach((item, index) => {
        compare[index] = item.length
      })
      let maxLen = Math.max(...compare)

      for (var index = 0; index < maxLen; index++) {
        let bHave = 0
        let name
        ary.forEach((item, idx) => {
          if (item[index]) {
            name = item[index].liabTypeName
          } else {
            bHave++
          }
        })
        // 存在其一则显示分类
        if (bHave !== ary.length && name) {
          result[index] = true
          this.liabTypeNameList.push(name)
        }
      }

      return result
    },
    _getPerson(key, persons) {
      let target
      for (var i = 0, j = persons.length; i < j; i++) {
        let person = persons[i]
        if (person.key === key) {
          let { age, sex } = person
          sex = sex === 2 ? '女' : '男'
          target = `${sex} ${age}岁`
          break
        }
      }
      return target
    },
    /**
     * 转义字符串模版
     * @param  {Number} prodId   [产品id]
     * @param  {String} template [pre模版]
     * @param  {Object} data     [计算数据]
     * @return {String}          [模版]
     */
    format(prodId, template, data) {
      let self = this
      let keys = Object.keys(data)
      let dataList
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      // 这里使用反引号来构建模板引擎
      // let Fn = new Function
      let g = new Function(
        keys.join(','),
        'return this.formatFnCenter `' + template + '`;'
      )
      return formatASCII(g.apply(self, dataList))
    },
    /**
     * ios8-5c fix (_format) 方法
     */
    formatLow(prodId, template, data) {
      let self = this
      let temps = template.split(/\$\{(\w?[^\}]*)\}/g)
      let match = template.match(/(\\)?\{([^\{\}\\]+)(\\)?\}/g)

      let dataList
      let keys = Object.keys(data)
      let result
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      if (match) {
        for (var i = 1; i < temps.length; i += 2) {
          let ret = new Function(
            keys.join(','),
            'return ' + temps[i] + ';'
          ).apply(self, dataList)

          // 金额显示整万
          if (temps[i + 1].match(/元/)) {
            ret = String(formatTenThousand(ret))
          }
          ret = '' + ret
          // 金额显示保留2位小数
          if (!isNaN(Number(ret)) && ret.split('.')[1]) {
            ret =
              ret.split('.')[1].length > 2 ? parseFloat(ret).toFixed(2) : ret
          }
          temps[i] = ret
        }
        result = temps.join('')
      } else {
        result = template
      }

      return formatASCII(result)
    },
    /**
     * 转义，公共函数
     * @param  {[type]} templateData [pre模版，数据]
     * @return {[type]}              [模版]
     */
    formatFnCenter(templateData) {
      var resultTemp = templateData[0]

      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i])

        // 金额显示整万
        if (templateData[i].match(/元/)) {
          arg = String(formatTenThousand(arg))
        }

        // 金额显示保留2位小数
        // fix 纯数字才进入逻辑
        if (!isNaN(arg) && arg.split('.')[1]) {
          arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
        }
        resultTemp += arg
        resultTemp += templateData[i]
      }
      return resultTemp
    },
  },
  // 依据大类型
  render: function (createElement) {
    this.__c = createElement
    let arrangeBase = []
    let temp = this.temp
    // let overview = []
    const width = Math.min(getScreenSize().width, 480)
    this.itemWidth = Math.round((width - LEFT_WIDTH) / 2)

    this.liabTypeNameList = []
    this.ovNameList = []

    let pbDiseaseBaseTypes = {}
    let pbInsuranceBaseCompare = {}

    for (var i = 0, j = temp.planLib.length; i < j; i++) {
      let plan = temp.planLib[i]
      const normalData = this._normalizeData(plan)
      arrangeBase[i] = normalData.arrangeBase

      let {
        // insuranceType: { companyName, companyNames },
        // resultData: {
        //   totalBaof,
        //   title,
        //   theme,
        //   personData: { personOrderList },
        //   productGroupList,
        // },
        uuid,
      } = plan

      pbDiseaseBaseTypes[uuid] = normalData.diseaseBaseTypes
      pbInsuranceBaseCompare[uuid] = normalData.insuranceBaseCompare

      // const firstProd = productGroupList[0].prodOrderList
      // let pPeriodDesc
      // let iDurationDesc
      // if (Array.isArray(firstProd) && Array.isArray(firstProd[0].mulInsOrderList)) {
      //   const firstIns = firstProd[0].mulInsOrderList[0]
      //   iDurationDesc = firstIns.iDurationDesc
      //   pPeriodDesc = firstIns.pPeriodDesc
      // }

      // overview.push({
      //   uuid,
      //   theme: theme || 'healthy',
      //   title,
      //   companyNames: companyNames ? companyNames.join(' / ') : (companyName ? companyName : '—'),
      //   // insured: this._getPerson('insuredInfo', personOrderList),
      //   iDurationDesc,
      //   pPeriodDesc,
      //   totalBaof
      // })
    }

    this.dispatch('InsResultContrast', 'set-distypes', {
      pbDiseaseBaseTypes,
      pbInsuranceBaseCompare,
    })

    let insTypeAry = []
    // let insOvAry = []
    let insPtAry = []
    let insTdAry = []

    const baseArray = this._getMaxLen(arrangeBase)
    insTypeAry = this._createInsTypeVNodeV2(baseArray, arrangeBase)

    let thePtAry = []
    let theAdAry = []
    let theNameAry = []
    temp.planLib.forEach((item, index) => {
      let desBtn = createElement('a', {
        class: 'open-profit after-bdr',
        attrs: {
          'data-stat-id': 'cklyysb',
        },
        on: {
          click: this.clickPftHandler.bind(this, event, index),
        },
        domProps: {
          innerHTML: '查看利益演示表',
        },
      })
      let desBox = createElement(
        'div',
        {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          },
        },
        [this.profitBtn[index] ? desBtn : '—']
      )

      let tradeBtn = '—'
      if (item.trades && Array.isArray(item.trades)) {
        const trades = item.trades[0]
        if (trades && trades.productInfo) {
          tradeBtn = createElement('a', {
            class: 'jumpto-trade after-bdr',
            attrs: {
              href: bApp
                ? trades.productInfo.tradeUrl
                : trades.productInfo.shareTradeUrl,
              'data-stat-id': 'ljtb',
            },
            domProps: {
              innerHTML: '立即投保',
            },
          })
        }
      }
      const tradeBox = createElement(
        'div',
        {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          },
        },
        [tradeBtn]
      )
      const nameBox = createElement(
        'div',
        {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          },
        },
        [item.resultData.title]
      )

      theAdAry.push(tradeBox)
      thePtAry.push(desBox)
      theNameAry.push(nameBox)
    })
    let theInsPtVNode = createElement(
      'div',
      {
        class: 'one-instype-item',
      },
      thePtAry
    )
    insPtAry.push(theInsPtVNode)

    let theInsTdVNode = createElement(
      'div',
      {
        class: 'one-instype-item',
      },
      theAdAry
    )
    insTdAry.push(theInsTdVNode)

    const theNameVNode = createElement(
      'div',
      {
        class: 'one-instype-item after-bd-b',
      },
      theNameAry
    )

    this.$nextTick(() => {
      const leftInfo = [
        {
          name: '',
          height: theNameVNode.elm.clientHeight,
        },
      ]

      insTypeAry.forEach((item, index) => {
        let _VNodeElm = item.elm
        leftInfo.push({
          name: this.liabTypeNameList[index],
          height: _VNodeElm.clientHeight,
        })
      })
      this.dispatch('InsResultContrast', 'init-left', leftInfo)
    })

    const planNameVNode = createElement(
      'div',
      {
        class: 'plan-book-overview',
      },
      [theNameVNode]
    )

    // const planOvVNode = createElement(
    //   'div',
    //   {
    //     class: 'plan-book-overview',
    //   },
    //   insOvAry
    // )

    const planLbVNode = createElement(
      'div',
      {
        class: 'plan-book-libility',
      },
      insTypeAry
    )

    const planPfVNode = createElement(
      'div',
      {
        class: 'plan-book-profit after-bd-b',
      },
      insPtAry
    )

    const tradingVNode = createElement(
      'div',
      {
        class: 'plan-book-trade',
      },
      insTdAry
    )

    const planBookVNode = createElement(
      'div',
      {
        class: 'plan-book-fast',
      },
      [planNameVNode, planLbVNode, planPfVNode, tradingVNode]
    )

    return planBookVNode
  },
}
</script>